<template>
    <el-card class="resourceWrapper">
        <div v-if="!resourceList.length" class="emptyList">暂无资源可查看</div>
        <div class="listWrapper" v-else>
            <div class="resourceItem" v-for="(item,index) in resourceList" :key="index">
                <router-link
                        tag="a"
                        target="_blank"
                        :to="{ name: 'ResourceDetail',query:{ rscId : item.rscID } }"
                        class="fileImg"
                        :class="fileClass(item.rscFileType)">
                    <div class="imgMask"><i></i></div>
                    <img :src="item.rscImage ? item.rscImage :'/styles/rescover.png'">
                </router-link>
                <div class="fileContent">
                    <h4>{{ item.title }}</h4>
                    <ul class="fileTags">
                        <li v-for="(tag,index) in item.tags" :key="index">{{ tag }}</li>
                    </ul>
                </div>
            </div>
            <el-pagination
                    class="paging"
                    :current-page="curIndex"
                    layout="prev, pager, next"
                    :total="pageTotal"
                    background
                    :page-size="pageSize"
                    prev-text="上一页"
                    next-text="下一页"
                    @current-change="handleCurrentChange"
            />
        </div>
    </el-card>
</template>
<script>
  import { getMyResourceList } from '@/api/resource';
  import { $Cookies } from '@/utils';

  export default {
    name: 'Resource',
    data () {
      return {
        curIndex: 1,
        pageSize: 5,
        pageTotal: 10,
        resourceList: []
      };
    },
    async mounted () {
      await this.getResourceList();
    },
    methods: {
      async getResourceList () {
        const uid = $Cookies.get('uid');
        const params = {
          userNo: uid,
          pageNum: this.curIndex,
          pageSize: this.pageSize
        };
        await getMyResourceList(params).then(data => {
          if (data.success) {
            this.pageSize = data.result.pageSize;
            this.pageTotal = data.result.total;
            this.curIndex = data.result.pageNum;
            const result  = data.result.list;
            if(result.length){
              result.map((item)=>{
              const tags = item.tags.length > 5 ? item.tags.slice(0,5) : item.tags;
              for(let i =0;i<tags.length;i++){
                if(tags[i].length > 10){
                  const item = tags[i].substr(0, 9) + '...';
                  tags[i] = item;
                }
              }
              item.tags = tags;
              return item;
            })
            }
            this.resourceList = result;
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      fileClass (type) {
        let className = '';
        if (type === 1 || type === 3) {
          className = 'resDoc';
        } else if (type === 2) {
          className = 'resVideo';
        } else if (type === 4) {
          className = 'resAudio';
        }
        return className;
      },
      handleCurrentChange (size) {
        this.curIndex = size;
        this.getResourceList();
      }
    }
  };
</script>
